export class ProgressHandler {
  public running: boolean;
  public progress: number;
  public totalSteps: number;
  public currentStepID: number;
  public currentStep: string;

  constructor() {
    this.progress = 0;
    this.currentStepID = 0;
    this.running = false;
  }

  public start(nbSteps: number) {
    this.totalSteps = nbSteps;
    this.running = true;
  }

  public next(stepDescription: string) {
    this.progress = (this.currentStepID / this.totalSteps) * 100;
    this.currentStepID++;
    this.currentStep = stepDescription;
  }

  public finish() {
    this.progress = 100;
    this.running = false;
  }
}
